import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export function InfoTip({ text, testId, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button type="button" aria-label="Nápoveda" data-testid={testId}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
            className={`inline-flex text-slate-400 hover:text-blue-700 transition-colors align-middle ${className}`}>
            <HelpCircle size={15} />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-relaxed font-normal normal-case tracking-normal">{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
